module.exports = __webpack_public_path__ + "img/HC_MAPP.24cb5259.svg";